import { render, staticRenderFns } from "./CustomTemplateSizeModal.vue?vue&type=template&id=49d026d4"
import script from "./CustomTemplateSizeModal.vue?vue&type=script&lang=js"
export * from "./CustomTemplateSizeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports